import Vue from 'vue'
import Router from 'vue-router'
//此VueRouter是自己自定义引入暴露出来的，即是自定义的，以下的VueRouter同样是这样
// 解决两次访问相同路由地址报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
import { routers } from './router'

Vue.use(Router)
// 路由配置
const RouterConfig = {
  mode:"history",
  base: window.__POWERED_BY_QIANKUN__ ? '/subApp/' : '/',
  routes: routers,
}
/**
 * 重写路由的push方法
 */

const router = new Router(RouterConfig)

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    next()
  } else {
    // let token = localStorage.getItem('token');
    // if (!token) {
    //   next('/');
    // } else {
    next()
    // }
  }
})

export default router
